var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogotyp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 32,
    viewBox: "0 0 152 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2776 0.288452H46.2759V11.2479H53.0142V14.4204H42.2776V0.288452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9402 11.3266V14.4204H54.6006V0.288452H65.678V3.38227H58.5465V5.76817H64.8259V8.75711H58.5465V11.3397H65.9402V11.3266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6335 11.6674H71.6557L70.5414 14.4073H66.4644L72.7044 0.288452H76.6372L82.9035 14.4204H78.7478L77.6335 11.6674ZM76.4668 8.71778L74.6446 4.19505L72.8224 8.71778H76.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2055 10.658H88.0294V14.4204H84.031V0.288452H90.4939C91.7786 0.288452 92.8798 0.498202 93.8237 0.930812C94.7676 1.35031 95.4886 1.96645 95.9999 2.75302C96.5111 3.53958 96.7733 4.47035 96.7733 5.5322C96.7733 6.55474 96.5374 7.44617 96.0523 8.20652C95.5804 8.96686 94.8856 9.55678 94.0072 9.98939L97.0617 14.4335H92.7881L90.2055 10.658ZM92.1064 3.97219C91.6869 3.60513 91.0707 3.42159 90.2449 3.42159H88.0294V7.56416H90.2449C91.0707 7.56416 91.6869 7.38063 92.1064 7.02667C92.5259 6.67272 92.7356 6.16146 92.7356 5.50599C92.7356 4.85052 92.5259 4.33925 92.1064 3.97219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.413 0.288452V14.4204H109.122L102.882 6.89558V14.4204H98.9757V0.288452H102.266L108.506 7.81324V0.288452H112.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.244 0.288452H119.243V14.4204H115.244V0.288452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.538 0.288452V14.4204H132.247L126.007 6.89558V14.4204H122.088V0.288452H125.378L131.618 7.81324V0.288452H135.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.821 7.03985H151.361V12.8997C150.548 13.4766 149.63 13.9223 148.569 14.2369C147.507 14.5515 146.471 14.6957 145.422 14.6957C143.941 14.6957 142.604 14.3811 141.424 13.7519C140.244 13.1226 139.313 12.2574 138.632 11.1431C137.963 10.0288 137.622 8.75718 137.622 7.34136C137.622 5.92555 137.963 4.66705 138.632 3.53964C139.3 2.42534 140.244 1.54702 141.437 0.930875C142.63 0.301625 143.993 -0.0130005 145.501 -0.0130005C146.825 -0.0130005 148.005 0.209859 149.054 0.655578C150.102 1.1013 150.981 1.74366 151.675 2.56955L149.132 4.8768C148.175 3.82805 147.035 3.30367 145.698 3.30367C144.492 3.30367 143.508 3.67074 142.774 4.40486C142.04 5.13899 141.66 6.12219 141.66 7.34136C141.66 8.12792 141.83 8.82272 142.158 9.42575C142.499 10.0419 142.971 10.5138 143.574 10.8547C144.177 11.1955 144.872 11.3659 145.658 11.3659C146.432 11.3659 147.14 11.2086 147.821 10.9071V7.03985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9163 31.5806C42.8413 31.2922 41.963 30.9251 41.2944 30.4532L42.6054 27.5036C43.2346 27.9231 43.9688 28.2639 44.8078 28.513C45.6468 28.7752 46.4595 28.8932 47.2723 28.8932C48.8061 28.8932 49.5796 28.513 49.5796 27.7396C49.5796 27.3332 49.3567 27.0317 48.9241 26.835C48.4915 26.6384 47.7836 26.4286 46.8135 26.2189C45.7516 25.996 44.8602 25.7469 44.1523 25.4847C43.4444 25.2226 42.8282 24.8031 42.317 24.2262C41.8057 23.6494 41.5435 22.8629 41.5435 21.8797C41.5435 21.0144 41.7795 20.241 42.2514 19.5462C42.7234 18.8514 43.4313 18.3008 44.362 17.8944C45.2928 17.488 46.4464 17.2914 47.8098 17.2914C48.7406 17.2914 49.6582 17.3963 50.5497 17.606C51.4542 17.8158 52.2408 18.1173 52.9356 18.5237L51.7033 21.4864C50.353 20.7654 49.0552 20.3983 47.7836 20.3983C46.9839 20.3983 46.4071 20.5163 46.0531 20.7523C45.6861 20.9882 45.5026 21.2897 45.5026 21.6699C45.5026 22.0501 45.7123 22.3254 46.1449 22.522C46.5775 22.7056 47.2723 22.9022 48.2293 23.1119C49.3043 23.3348 50.1957 23.5839 50.9036 23.8461C51.6115 24.1083 52.2277 24.5278 52.739 25.0915C53.2633 25.6683 53.5124 26.4417 53.5124 27.4249C53.5124 28.277 53.2764 29.0374 52.8045 29.7322C52.3326 30.4139 51.6247 30.9645 50.6808 31.384C49.7369 31.7904 48.5964 32.0001 47.2461 32.0001C46.1056 32.0001 44.9913 31.8559 43.9163 31.5806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1404 18.2221C66.0842 18.6416 66.8053 19.2577 67.3165 20.0443C67.8278 20.8309 68.09 21.7616 68.09 22.8235C68.09 23.8853 67.8278 24.803 67.3165 25.5896C66.8053 26.3761 66.0842 26.966 65.1404 27.3987C64.1965 27.8182 63.0822 28.041 61.8106 28.041H59.346V31.7247H55.3477V17.5928H61.8106C63.0822 17.5928 64.1965 17.8026 65.1404 18.2221ZM63.423 24.3442C63.8425 23.9902 64.0523 23.4789 64.0523 22.8235C64.0523 22.168 63.8425 21.6567 63.423 21.2897C63.0035 20.9226 62.3874 20.7391 61.5615 20.7391H59.346V24.8817H61.5615C62.3874 24.8817 63.0035 24.6981 63.423 24.3442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7873 28.9719H72.8095L71.6952 31.7117H67.6182L73.8582 17.5798H77.791L84.0573 31.7249H79.9016L78.7873 28.9719ZM77.6075 26.0223L75.7984 21.4995L73.9762 26.0223H77.6075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0425 31.0693C86.8627 30.44 85.945 29.5748 85.2633 28.4605C84.5948 27.3462 84.2539 26.0746 84.2539 24.6588C84.2539 23.243 84.5948 21.9845 85.2633 20.8571C85.9319 19.7428 86.8627 18.8645 88.0425 18.2483C89.2224 17.6191 90.5464 17.3044 92.0278 17.3044C93.3256 17.3044 94.4793 17.5273 95.5149 17.9861C96.5505 18.445 97.4158 19.1004 98.0975 19.9656L95.5542 22.2729C94.6366 21.1717 93.5223 20.6211 92.2244 20.6211C91.451 20.6211 90.7693 20.7915 90.1794 21.1324C89.5763 21.4732 89.1175 21.9452 88.7898 22.5613C88.462 23.1774 88.2916 23.8722 88.2916 24.6719C88.2916 25.4716 88.462 26.1664 88.7898 26.7825C89.1175 27.3987 89.5894 27.8706 90.1794 28.2114C90.7824 28.5523 91.4641 28.7227 92.2244 28.7227C93.5354 28.7227 94.6366 28.1721 95.5542 27.0709L98.0975 29.3782C97.4158 30.2434 96.5505 30.8989 95.5149 31.3577C94.4793 31.8165 93.3125 32.0394 92.0278 32.0394C90.5464 32.0001 89.2224 31.6854 88.0425 31.0693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.22 28.6309V31.7247H99.8804V17.5928H110.958V20.6866H103.826V23.0726H110.119V26.0615H103.839V28.644H111.22V28.6309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9751 0.275208C15.1807 0.275208 10.4875 4.96837 10.4875 10.7627H20.9751V0.275208Z",
    fill: "url(#paint0_linear_1_241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9751 10.7627C26.7694 10.7627 31.4626 6.06955 31.4626 0.275208H20.9751V10.7627Z",
    fill: "url(#paint1_linear_1_241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9751 21.2502V10.7627H10.4875C10.4875 16.557 15.1807 21.2502 20.9751 21.2502Z",
    fill: "#00ACC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4626 21.2502C31.4626 15.4559 26.7694 10.7627 20.9751 10.7627V21.2502H31.4626Z",
    fill: "url(#paint2_linear_1_241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9751 31.7377C26.7694 31.7377 31.4626 27.0446 31.4626 21.2502H20.9751V31.7377Z",
    fill: "url(#paint3_linear_1_241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4875 10.7627C10.4875 4.96837 5.79435 0.275208 0 0.275208V10.7627H10.4875Z",
    fill: "#00ACC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.7627C0 16.557 4.69316 21.2502 10.4875 21.2502V10.7627H0Z",
    fill: "url(#paint4_linear_1_241)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.2502C0 27.0446 4.69316 31.7377 10.4875 31.7377V21.2502H0Z",
    fill: "#00ACC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9751 31.7377C20.9751 25.9434 16.2819 21.2502 10.4875 21.2502V31.7377H20.9751Z",
    fill: "url(#paint5_linear_1_241)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_241",
    x1: 10.4875,
    y1: 5.52064,
    x2: 20.9751,
    y2: 5.52064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_241",
    x1: 20.9751,
    y1: 5.52064,
    x2: 31.4626,
    y2: 5.52064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_241",
    x1: 20.9751,
    y1: 16.0081,
    x2: 31.4626,
    y2: 16.0081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_241",
    x1: 26.2188,
    y1: 31.7394,
    x2: 26.2188,
    y2: 21.2519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_241",
    x1: 0.00000342726,
    y1: 16.0081,
    x2: 10.4875,
    y2: 16.0081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_241",
    x1: 10.4875,
    y1: 26.4957,
    x2: 20.9751,
    y2: 26.4957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC1",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACC1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151.689,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotyp);
export default __webpack_public_path__ + "static/media/logotyp.28a5f62b815b90e4a2d4b2c3af6f611c.svg";
export { ForwardRef as ReactComponent };